import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['wrapper', 'navItemDesktop', 'navItemMobile'];

  static classes = ['wrapper', 'scrollUp', 'scrollUpSm', 'scrollUpMd', 'scrollDown', 'active'];

  // TARGETS
  declare wrapperTarget?: HTMLElement;
  declare readonly hasWrapperTarget: boolean;
  declare readonly hasNavItemDesktopTarget: boolean;
  declare readonly hasNavItemMobileTarget: boolean;

  // CLASSES
  declare wrapperClasses?: string[];
  declare scrollUpClasses?: string[];
  declare scrollUpSmClasses?: string[];
  declare scrollUpMdClasses?: string[];
  declare scrollDownClasses?: string[];
  declare activeClasses?: string[];
  declare readonly hasWrapperClass: boolean;
  declare readonly hasActiveClass: boolean;

  // LOCAL STATE
  private lastScroll: number;
  private headerHeight = 0;

  mount() {
    if (this.hasNavItemDesktopTarget && this.hasNavItemMobileTarget) {
      const navItemsDesktop = this.navItemDesktopTargets;
      const navItemsMobile = this.navItemMobileTargets;

      // Adds a custom active class to the nav item that is clicked. Useful for displaying a focus/border on the active nav item.
      if (this.hasActiveClass) {
        [navItemsDesktop, navItemsMobile].forEach((navItems) => {
          // Set the first nav item as active by default for desktop and mobile
          if (navItems.length > 0) {
            navItems[0].classList.add(...this.activeClasses);
          }
        });
      }
    }
  }

  initialize() {
    this.mount();
  }

  connect() {
    this.lastScroll = 0;

    if (this.hasWrapperTarget && this.hasWrapperClass) {
      const sectionParent = this.wrapperTarget.closest('section');
      if (sectionParent) {
        sectionParent.className = this.wrapperClasses.join(' ');
      }
    }
  }

  handleClick(event) {
    if (this.hasNavItemDesktopTarget && this.hasNavItemMobileTarget) {
      const navItems = this.navItemDesktopTargets.concat(this.navItemMobileTargets);

      if (this.activeClasses) {
        navItems.forEach((item) => {
          item.classList.remove(...this.activeClasses);
        });
        event.currentTarget.classList.add(...this.activeClasses);
      }
    }
  }

  handleScroll() {
    const currentScroll = window.scrollY;

    let sectionParent;
    if (this.hasWrapperTarget) {
      sectionParent = this.wrapperTarget.closest('section');
    }

    let scrollUpClasses = this.scrollUpClasses;
    if (window.innerWidth < 1024) {
      scrollUpClasses = this.scrollUpMdClasses;
    }
    if (window.innerWidth < 768) {
      scrollUpClasses = this.scrollUpSmClasses;
    }

    if (sectionParent) {
      if (currentScroll >= this.lastScroll && currentScroll > (this.headerHeight || 0)) {
        // Remove all the scroll-up-classes in the case that screen size changes and a user scrolls again.
        sectionParent.classList.remove(
          ...this.scrollUpClasses,
          ...this.scrollUpMdClasses,
          ...this.scrollUpSmClasses
        );
        sectionParent.classList.add(...this.scrollDownClasses);
        sectionParent.classList.add(...this.wrapperClasses);
      } else {
        sectionParent.classList.remove(...this.scrollDownClasses);
        sectionParent.classList.add(...scrollUpClasses);
        sectionParent.classList.add(...this.wrapperClasses);
      }
    }

    this.lastScroll = currentScroll;
  }
}
